import { AppDataTable } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { useMemo } from 'react'
import { createSalesColumns } from './components/columns'
import { useInquirySales } from './hooks/useInquirySales'

type SalesTabProps = {
  inquiryId: number
}

export function SalesTab({ inquiryId }: SalesTabProps) {
  const { data, isLoading } = useInquirySales(inquiryId)
  const sales = data?.sales ?? []
  const columns = useMemo(() => createSalesColumns(), [])

  return (
    <AppDataTable
      data={sales}
      columns={columns}
      isLoading={isLoading}
      pageSize={20}
      defaultSortKey='sales_id'
      defaultSortDirection='desc'
      getRowKey={(row) => row.id}
      emptyMessage='売上情報はありません'
    />
  )
}
